var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1OverviewSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.523 8.941H8.544l4.648 4.648c.178.178.47.192.653.02a7.044 7.044 0 002.15-4.143.471.471 0 00-.472-.525zm-.465-1.906A7.076 7.076 0 008.494.472.473.473 0 008 .948V7.53h6.582a.473.473 0 00.476-.494zm-8.47 1.906V1.962a.471.471 0 00-.524-.472 7.054 7.054 0 00-6.06 7.227c.128 3.769 3.373 6.86 7.144 6.812a7.004 7.004 0 003.978-1.295.467.467 0 00.046-.708L6.588 8.94z",
    fill: "#9FA2B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1OverviewSvg);
export default __webpack_public_path__ + "static/media/_1OverviewSvg.15938429827399a1734864b32fc5803d.svg";
export { ForwardRef as ReactComponent };